import RequestHandler from './request-handler';

class Service {
  constructor(apiUrl, options) {
    this.apiUrl = apiUrl;
    this.options = Object.assign({}, options);
  }
  /**
   * DELETE relative `path` with optional `options`.
   *
   * @method delete
   * @param {String} path
   * @param {Object} options
   * @return {Promise}
   * @public
   */
  delete(path, data, options) {
    options = Object.assign({}, this.options, options);
    return RequestHandler.del(this.apiUrl + path, data, options);
  }

  /**
   * GET relative `path` with optional `data` and `options`.
   *
   * @method get
   * @param {String} path
   * @param {Mixed} data
   * @return {Promise}
   * @public
   */
  get(path, data, options) {
    options = Object.assign({}, this.options, options);
    return RequestHandler.get(this.apiUrl + path, data, options);
  }

  /**
   * PATCH relative `path` with optional `data` and `options`.
   *
   * @method patch
   * @param {String} path
   * @param {Mixed} data
   * @return {Promise}
   * @public
   */
  patch(path, data, options) {
    options = Object.assign({}, this.options, options);
    return RequestHandler.patch(this.apiUrl + path, data, options);
  }

  /**
   * POST relative `path` with optional `data` and `options`.
   *
   * @method post
   * @param {String} path
   * @param {Mixed} data
   * @return {Promise}
   * @public
   */
  post(path, data, options) {
    options = Object.assign({}, this.options, options);
    return RequestHandler.post(this.apiUrl + path, data, options);
  }

  /**
   * PUT relative `path` with optional `data` and `options`.
   *
   * @method put
   * @param {String} path
   * @param {Mixed} data
   * @return {Promise}
   * @public
   */
  put(path, data, options) {
    options = Object.assign({}, this.options, options);
    return RequestHandler.put(this.apiUrl + path, data, options);
  }
}

export default Service;
